/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment, } from "react";
import LayoutOperation from "../../components/layout_operation";
import {
  Table,
  Input,
  Select,
  Modal,
  Menu,
  Dropdown,
  Form,
  DatePicker,
  Spin,

} from "antd";
import Api from "../../services/ServiceApi";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import ModalSuccess from "../../components/Modal_Success";
import XLSX from 'xlsx';



const { Option } = Select;
function setCookies(item, active) {
  localStorage.setItem("informDetail", JSON.stringify(item));
  localStorage.setItem("active", active);
  setTimeout(function () {
    window.location.assign("/MaxiOperation/inform_problem_detail");
  }, 1000);
}

class LeaveList extends Component {
  rejectForm = React.createRef();
  filterRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      title: "Leave Management",
      tab: [{ text: "All" },
      { text: "Wait Approve" },
      { text: "Approved" }],
      current_option: 1,
      columns: [
        {
          title: "Doc No.",
          key: "doc_no",
          render: (item) => (
            <a className="c-blue text-underline" onClick={() => this.onOpenModal("approve", item)}>{item.doc_no}</a>
          ),
          sorter: (a, b) => { if ((a.doc_no !== undefined && b.doc_no !== undefined) && (a.doc_no !== null && b.doc_no !== null)) { return a.doc_no.localeCompare(b.doc_no) } }
        },
        {
          title: "Employee Name",
          key: "emp_name",
          render: (item) => { return !item.emp_name ? "-" : item.emp_name; },
          sorter: (a, b) => { if ((a.emp_name !== undefined && b.emp_name !== undefined) && (a.emp_name !== null && b.emp_name !== null)) { return a.emp_name.localeCompare(b.emp_name) } }
        },
        {
          title: "Employee Nickname",
          key: "emp_nickname",
          render: (item) => { return !item.emp_nickname ? "-" : item.emp_nickname; },
          sorter: (a, b) => { if ((a.emp_nickname !== undefined && b.emp_nickname !== undefined) && (a.emp_nickname !== null && b.emp_nickname !== null)) { return a.emp_nickname.localeCompare(b.emp_nickname) } }
        },
        {
          title: "Remark",
          key: "remark",
          render: (item) => { return !item.remark ? "-" : item.remark; },
          sorter: (a, b) => { if ((a.remark !== undefined && b.remark !== undefined) && (a.remark !== null && b.remark !== null)) { return a.remark.localeCompare(b.remark) } }
        },
        {
          title: "Leave Type",
          render: (item) => {
            if (item.leave_type_id === 1) { return "ลาป่วย"; }
            else if (item.leave_type_id === 2) { return "ลาพักร้อน"; }
            else if (item.leave_type_id === 3) { return "ลากิจ"; }
          },
          key: "leave_type_id",
          sorter: (a, b) => a.inform_date.localeCompare(b.inform_date),
        },
        {
          title: "Inform Date",
          key: "inform_date",
          render: (item) => { return !item.inform_date ? "-" : this.dateFormat(item.inform_date); },
          sorter: (a, b) => { if ((a.inform_date !== undefined && b.inform_date !== undefined) && (a.inform_date !== null && b.inform_date !== null)) { return a.inform_date.localeCompare(b.inform_date) } }
        },
        {
          title: "Start Date",
          key: "start_date",
          render: (item) => { return !item.start_date ? "-" : this.dateFormat(item.start_date); },
          sorter: (a, b) => {
            if ((a.start_date !== undefined && b.start_date !== undefined) && (a.start_date !== null && b.start_date !== null)) { return a.start_date.localeCompare(b.start_date) }
          }
        },

        {
          title: "End Date",
          key: "end_date",
          render: (item) => { return !item.end_date ? "-" : this.dateFormat(item.end_date); },
          sorter: (a, b) => {
            if ((a.end_date !== undefined && b.end_date !== undefined) && (a.end_date !== null && b.end_date !== null)) { return a.end_date.localeCompare(b.end_date) }
          }
        },
        {
          title: "Total Time",
          key: "total_day",
          render: (item) => { return !item.total_day ? "-" : item.total_day + " Days"; },
          sorter: (a, b) => {
            if ((a.total_day !== undefined && b.total_day !== undefined) && (a.total_day !== null && b.total_day !== null)) { return a.total_day.localeCompare(b.total_day) }
          }
        },
        {
          title: "Status",
          key: "status",
          align: "center",
          render: (item) => (
            <div>
              {item.status === "approved" ?
                <span className="badge badge-pill badge-light on-process font-thai-b font14">
                  <span>Approved</span>
                </span>
                : null}

              {item.status === "wait approve" ?
                <span className="badge badge-pill badge-light wait-approve font-thai-b font14">
                  <span>Wait Approve</span>
                </span>
                : null}

              {item.status === "rejected" ?
                <span className="badge badge-pill badge-danger wait-approve font-thai-b font14">
                  <span>Rejected</span>
                </span>
                : null}
            </div>
          ),
          sorter: (a, b) => { if ((a.status !== undefined && b.status !== undefined) && (a.status !== null && b.status !== null)) { return a.status.localeCompare(b.status) } }
        },
        {
          title: "Action",
          align: "center",
          render: (item) => (item.status == "wait approve" ?
          localStorage.getItem("checkPermission") === "1" ? 
            <div className="dropdown">
              <Dropdown overlay={
                <Menu>
                  <Menu.Item key="1">
                    <a className="c-blue" onClick={() => this.onOpenModal("approve", item)} >
                      <img src={Api.absoluteUrl("/icon/approve_menu.svg")} className="mr-2" />
                      Approve
                    </a>
                  </Menu.Item>
                  <Menu.Item key="2">
                    <a className="c-blue" onClick={() => this.onOpenModal("reject", item)} >
                      <img src={Api.absoluteUrl("/icon/reject_icon.svg")} className="mr-2" />
                      Reject
                    </a>
                  </Menu.Item>
                </Menu>
              } trigger={['click']}>
                <a className="ant-dropdown-link c-blue" onClick={e => e.preventDefault()}>
                  <img src={Api.absoluteUrl("/icon/3_dot.svg")} className="mr-2" />
                </a>
              </Dropdown>
            </div>
            :"-"
            :
            "-"),
        },
      ],

      data: [],
      original_data: [],
      total: [],
      display_load: false,
      loading: true,
      columns_leave_request: [
        {
          title: "Job No.",
          key: "job_no",
          render: (item) => { return item.job_no ? <span className="c-blue text-underline"> {item.job_no} </span> : "-" },
        },
        {
          title: "Job Category",
          key: "job_category_id",
          render: (item) => { return item.job_category_id ? <span>{this.filterJobCategory(item)} </span> : "-" },
        },
        {
          title: "Asset Name",
          key: "locatioN_NAME",
          render: (item) => { return (item.locatioN_NAME ? item.locatioN_NAME : "-") },
        },
        {
          title: "Status",
          key: "current_status",
          render: (item) => (
            <div>
              {item.current_status == "Wait Ack Job" ||
                item.current_status == "Wait Depart (Sub)" ||
                item.current_status == "Wait On Site (Sub)" ||
                item.current_status == "Wait Start Time(Fix problem)" ||
                item.current_status == "Wait Start Time (On Site)" ||
                item.current_status == "Wait Fix Problem (Sub)" ||
                item.current_status == "Wait Start Time (Depart)" ||
                item.current_status == "Wait Finished (Sub)" ||
                item.current_status == "Wait TL Approve/Reject" ||
                item.current_status == "Review Stop Time (Depart)" ||
                item.current_status == "Review Stop Time (On Site)" ||
                item.current_status == "Review Stop Time (Fix Problem)" ||

                item.current_status == "End Sub Process"
                ?
                <span className="badge badge-pill badge-light on-process font-thai-b font14">
                  {item.current_status}
                </span>
                : null}
            </div>
          )
        },

      ],
      active: 0,
      visible_request: false,
      maseter_reject: [],
      visible_modal_reject: false,
      visible_reject_success: false,
      visible_reject_failed: false,
      visible_approve: false,
      filterTable: null,
      visible_request_multi: false,
      selectedRowlist: [],

      all_data: [],
      wait_approved_data: [],
      approved_data: [],
      modal_data: {},
      modal_type: "",
      emp_job: [],
      appv_check: [],
      appv_check_emp_single_job: [],
      appv_check_emp_multi_job: [],

      data_multi_emp: [],
      loading_multi: false,
      loading_reject: false,
      loading_approve: false,
      leave_type_list: [
        { leave_reason_id: 1, leave_reason_detail: "ลาป่วย" },
        { leave_reason_id: 2, leave_reason_detail: "ลาพักร้อน" },
        { leave_reason_id: 3, leave_reason_detail: "ลากิจ" },
      ],
      job_category_list: [],
      count_list: [],
      default_startdate: new Date("2020"),
      default_enddate: new Date(new Date().setFullYear(new Date().getFullYear() + 1000)),
      reject_form: {},
      attach_file: [],
      checkBtn : false
    };
  }

  // // For Showing check button
  state = {
    selectedRowKeys: [],
  };

  async componentDidMount() {
    document.title = this.state.title;

    Api.post("get_leave", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      status: "",
      start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
      end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
    })
      .then((val) => {
        this.setState({
          all_data: val.data.data,
          loading: false,
        });
      });

    Api.post("get_leave", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      status: "wait approve",
      start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
      end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
    })
      .then((val) => {
        this.setState({
          wait_approved_data: val.data.data,
          loading: false,
        });
      });

    Api.post("get_leave", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      status: "approved",
      start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
      end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
    })
      .then((val) => {
        this.setState({
          approved_data: val.data.data,
          loading: false,
        });
      });

    Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
    })
      .then((val) => {
        this.setState({
          job_category_list: val.data.data.result_data,
          loading: false,
        });
      });

    Api.post("get_reason_count_employee", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id")
    })
      .then((val) => {
        this.setState({
          count_list: val.data.data,
        });
      });



  }

  filterJobCategory(item) {
    const temp_filter = this.state.job_category_list.filter((element) => { return element.job_category_id == item.job_category_id })
    return temp_filter[0].job_category_name;
  }


  async handleDateStartEnd(date1, date2, obj) {
    await this.setState({
      loading: true
    })

    const { active, all_data, wait_approved_data, approved_data, default_enddate, default_startdate } = this.state

    if (obj) {
      // var filtereddata = [];
      var imported_data = [];
      if (active == 0) {
        imported_data = all_data;
      } else if (active == 1) {
        imported_data = wait_approved_data;
      } else if (active == 2) {
        imported_data = approved_data;
      }
      // var new_start_date = new Date(startdate);
      // new_start_date.setDate(new_start_date.getDate() + 1)
      var new_end_date = new Date(obj[1]);
      new_end_date.setDate(new_end_date.getDate() + 1)



      // filtereddata = await imported_data.filter(function(obj) {

      //   return (  moment(obj.start_date).format("YYYY-MM-DD") >= startdate &&   moment(obj.start_date).format("YYYY-MM-DD") < enddate  ) && 
      //         (  moment(obj.end_date).format("YYYY-MM-DD")   >  startdate &&   moment(obj.end_date).format("YYYY-MM-DD")   <= enddate   ) ;
      // })




      // var startdate = moment(obj[0]).format("YYYY-MM-DD");
      // var enddate = moment(obj[1]).format("YYYY-MM-DD");
      var startdate = moment(obj[0]).format("YYYY-MM-DD");
      var enddate = moment(new_end_date).format("YYYY-MM-DD");
      if (active == 0) {
        await Api.post("get_leave", {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          status: "",
          start_date: startdate,
          end_date: enddate,
        })
          .then((val) => {
            this.setState({
              all_data: val.data.data,
              loading: false,
            });
          });
      } else if (active == 1) {
        Api.post("get_leave", {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          status: "wait approve",
          start_date: startdate,
          end_date: enddate,
        })
          .then((val) => {
            this.setState({
              wait_approved_data: val.data.data,
              loading: false,
            });
          });
      } else if (active == 2) {
        Api.post("get_leave", {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          status: "approved",
          start_date: startdate,
          end_date: enddate,
        })
          .then((val) => {
            this.setState({
              approved_data: val.data.data,
              loading: false,
            });
          });
      }
    } else {
      if (active == 0) {
        await Api.post("get_leave", {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          status: "",
          start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
          end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
        })
          .then((val) => {
            this.setState({
              all_data: val.data.data,
              loading: false,
            });
          });
      } else if (active == 1) {
        Api.post("get_leave", {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          status: "wait approve",
          start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
          end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
        })
          .then((val) => {
            this.setState({
              wait_approved_data: val.data.data,
              loading: false,
            });
          });
      } else if (active == 2) {
        Api.post("get_leave", {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          status: "approved",
          start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
          end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
        })
          .then((val) => {
            this.setState({
              approved_data: val.data.data,
              loading: false,
            });
          });
      }
    }
  }

  async handleSubmit(values, name) {
    const { modal_type, modal_data, appv_check, appv_check_emp_multi_job, appv_check_emp_single_job, emp_job } = this.state;
    if (modal_type == "reject") {
      this.setState({
        loading_reject: true
      })
      modal_data.leave_reason_id = values.leave_reason_id;
      modal_data.leave_reason_detail = this.state.reject_form.leave_reason_detail;
      modal_data.status = "rejected";
      modal_data.leave_reason_remark = values.leave_reason_remark;
      await Api.post("save_leave", modal_data)
        .then((val) => {
          if (val.data.result.code !== "F") {
            this.OnViewApprove(this.renderApproveButtonModal())
            this.rejectForm.current.resetFields();

            Api.post("get_leave", {
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              project_id: Cookies.get("project_id"),
              status: "",
              start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
              end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
            })
              .then((val) => {
                this.setState({
                  all_data: val.data.data,
                });
              });

            Api.post("get_leave", {
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              project_id: Cookies.get("project_id"),
              status: "wait approve",
              start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
              end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
            })
              .then((val) => {
                this.setState({
                  wait_approved_data: val.data.data,
                  loading: false,
                });
              });

            Api.post("get_leave", {
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              project_id: Cookies.get("project_id"),
              status: "approved",
              start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
              end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
            })
              .then((val) => {
                this.setState({
                  approved_data: val.data.data,
                  loading: false,
                });
              });

            this.setState({
              visible_modal_reject: false, // Still dont have API
              loading_reject: false,
              reject_form: {},
            })
            window.location.reload();
          } else {
            this.OnViewRejectFailed(this.renderRejectButtonModal())
          }
        });


    } else if (modal_type == "approve") {
      this.setState({
        loading_approve: true
      })
      // do the approve thing here get_leave_approve


      modal_data.status = "approved";
      var approved_single_emp_job = [];
      for (let i = 0; i < appv_check_emp_single_job.length; i++) {
        approved_single_emp_job.push({
          // Required
          company_id: (appv_check_emp_single_job[i].company_id ? appv_check_emp_single_job[i].company_id : null),
          operator_id: (appv_check_emp_single_job[i].operator_id ? appv_check_emp_single_job[i].operator_id : null),
          project_id: (appv_check_emp_single_job[i].project_id ? appv_check_emp_single_job[i].project_id : null),
          job_id: (appv_check_emp_single_job[i].job_id ? appv_check_emp_single_job[i].job_id : null),
          job_progress_id: (appv_check_emp_single_job[i].job_progress_id ? appv_check_emp_single_job[i].job_progress_id : null),
          location_lat: (appv_check_emp_single_job[i].location_lat ? appv_check_emp_single_job[i].location_lat : null),
          location_long: (appv_check_emp_single_job[i].location_long ? appv_check_emp_single_job[i].location_long : null),
          progress_Status_flag: (appv_check_emp_single_job[i].progress_Status_flag ? appv_check_emp_single_job[i].progress_Status_flag : null),
          reject_service_ma_reason_id: (appv_check_emp_single_job[i].reject_service_ma_reason_id ? appv_check_emp_single_job[i].reject_service_ma_reason_id : null),
          reject_service_ma_remark: (appv_check_emp_single_job[i].reject_service_ma_remark ? appv_check_emp_single_job[i].reject_service_ma_remark : null),
          create_by: Cookies.get("userId"),
          jobtypeid: (appv_check_emp_single_job[i].jobtypeid ? appv_check_emp_single_job[i].jobtypeid : null),
          wf_id: (appv_check_emp_single_job[i].wf_id ? appv_check_emp_single_job[i].wf_id : null),
          is_active: (appv_check_emp_single_job[i].is_active ? appv_check_emp_single_job[i].is_active : null),
          job_category_name: (appv_check_emp_single_job[i].job_category_name ? appv_check_emp_single_job[i].job_category_name : null),
          job_no: (appv_check_emp_single_job[i].job_no ? appv_check_emp_single_job[i].job_no : null),
          job_sub_type_id: (appv_check_emp_single_job[i].job_sub_type_id ? appv_check_emp_single_job[i].job_sub_type_id : null),
          job_sub_type_name: (appv_check_emp_single_job[i].job_sub_type_name ? appv_check_emp_single_job[i].job_sub_type_name : null),
          job_type_name: (appv_check_emp_single_job[i].job_type_name ? appv_check_emp_single_job[i].job_type_name : null),
          locatioN_NAME: (appv_check_emp_single_job[i].locatioN_NAME ? appv_check_emp_single_job[i].locatioN_NAME : null),
          mainProcessID: (appv_check_emp_single_job[i].mainProcessID ? appv_check_emp_single_job[i].mainProcessID : null),
          next_main_process_name: (appv_check_emp_single_job[i].next_main_process_name ? appv_check_emp_single_job[i].next_main_process_name : null),
          next_sub_process_name: (appv_check_emp_single_job[i].next_sub_process_name ? appv_check_emp_single_job[i].next_sub_process_name : null),
          service_ma_reason_id: (appv_check_emp_single_job[i].service_ma_reason_id ? appv_check_emp_single_job[i].service_ma_reason_id : null),
          subProcessID: (appv_check_emp_single_job[i].subProcessID ? appv_check_emp_single_job[i].subProcessID : null),
        })
      }

      // await Api.post("save_leave", modal_data)
      await Api.post("leave_cancel_job", approved_single_emp_job)
        .then((val) => {
          if (val.data.result.code !== "F") {
            Api.post("save_leave", modal_data)
              .then((val) => {
                if (val.data.result.code !== "F") {
                  this.OnViewApprove(this.renderApproveButtonModal())

                  Api.post("get_leave", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    status: "",
                    start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                    end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
                  })
                    .then((val) => {
                      this.setState({
                        all_data: val.data.data,
                      });
                    });

                  Api.post("get_leave", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    status: "wait approve",
                    start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                    end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
                  })
                    .then((val) => {
                      this.setState({
                        wait_approved_data: val.data.data,
                      });
                    });

                  Api.post("get_leave", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    status: "approved",
                    start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                    end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
                  })
                    .then((val) => {
                      this.setState({
                        approved_data: val.data.data,
                      });
                    });

                  // this.setState({
                  //   loading_approve: false,
                  // })

                } else {
                  this.OnViewRejectFailed(this.renderRejectButtonModal())
                }
              });

          } else {
            this.OnViewRejectFailed(this.renderRejectButtonModal())
          }
        });
      await this.setState({
        loading_approve: false,
      });



    } else if (modal_type == "approve multi") {
      await this.setState({
        loading_multi: true,
      })

      var approved_multi_emp_job = [];
      for (let i = 0; i < appv_check_emp_multi_job.length; i++) {
        approved_multi_emp_job.push({
          // Required
          company_id: (appv_check_emp_multi_job[i].company_id ? appv_check_emp_multi_job[i].company_id : null),
          operator_id: (appv_check_emp_multi_job[i].operator_id ? appv_check_emp_multi_job[i].operator_id : null),
          project_id: (appv_check_emp_multi_job[i].project_id ? appv_check_emp_multi_job[i].project_id : null),
          job_id: (appv_check_emp_multi_job[i].job_id ? appv_check_emp_multi_job[i].job_id : null),
          job_progress_id: (appv_check_emp_multi_job[i].job_progress_id ? appv_check_emp_multi_job[i].job_progress_id : null),
          location_lat: (appv_check_emp_multi_job[i].location_lat ? appv_check_emp_multi_job[i].location_lat : null),
          location_long: (appv_check_emp_multi_job[i].location_long ? appv_check_emp_multi_job[i].location_long : null),
          progress_Status_flag: (appv_check_emp_multi_job[i].progress_Status_flag ? appv_check_emp_multi_job[i].progress_Status_flag : null),
          reject_service_ma_reason_id: (appv_check_emp_multi_job[i].reject_service_ma_reason_id ? appv_check_emp_multi_job[i].reject_service_ma_reason_id : null),
          reject_service_ma_remark: (appv_check_emp_multi_job[i].reject_service_ma_remark ? appv_check_emp_multi_job[i].reject_service_ma_remark : null),
          create_by: Cookies.get("userId"),
          jobtypeid: (appv_check_emp_multi_job[i].jobtypeid ? appv_check_emp_multi_job[i].jobtypeid : null),
          wf_id: (appv_check_emp_multi_job[i].wf_id ? appv_check_emp_multi_job[i].wf_id : null),
          is_active: (appv_check_emp_multi_job[i].is_active ? appv_check_emp_multi_job[i].is_active : null),
          job_category_name: (appv_check_emp_multi_job[i].job_category_name ? appv_check_emp_multi_job[i].job_category_name : null),
          job_no: (appv_check_emp_multi_job[i].job_no ? appv_check_emp_multi_job[i].job_no : null),
          job_sub_type_id: (appv_check_emp_multi_job[i].job_sub_type_id ? appv_check_emp_multi_job[i].job_sub_type_id : null),
          job_sub_type_name: (appv_check_emp_multi_job[i].job_sub_type_name ? appv_check_emp_multi_job[i].job_sub_type_name : null),
          job_type_name: (appv_check_emp_multi_job[i].job_type_name ? appv_check_emp_multi_job[i].job_type_name : null),
          locatioN_NAME: (appv_check_emp_multi_job[i].locatioN_NAME ? appv_check_emp_multi_job[i].locatioN_NAME : null),
          mainProcessID: (appv_check_emp_multi_job[i].mainProcessID ? appv_check_emp_multi_job[i].mainProcessID : null),
          next_main_process_name: (appv_check_emp_multi_job[i].next_main_process_name ? appv_check_emp_multi_job[i].next_main_process_name : null),
          next_sub_process_name: (appv_check_emp_multi_job[i].next_sub_process_name ? appv_check_emp_multi_job[i].next_sub_process_name : null),
          service_ma_reason_id: (appv_check_emp_multi_job[i].service_ma_reason_id ? appv_check_emp_multi_job[i].service_ma_reason_id : null),
          subProcessID: (appv_check_emp_multi_job[i].subProcessID ? appv_check_emp_multi_job[i].subProcessID : null),
        })
      }

      await Api.post("leave_cancel_job", approved_multi_emp_job)
        .then((val) => {
          if (val.data.result.code !== "F") {
            for (let i = 0; i < appv_check.length; i++) {
              appv_check[i].status = "approved";
            }
            Api.post("save_leave_multi", appv_check)
              .then((val) => {
                if (val.data.result.code != "F") {
                  this.OnViewApprove(this.renderApproveButtonModal())

                  Api.post("get_leave", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    status: "",
                    start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                    end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
                  })
                    .then((val) => {
                      this.setState({
                        all_data: val.data.data,
                      });
                    });

                  Api.post("get_leave", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    status: "wait approve",
                    start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                    end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
                  })
                    .then((val) => {
                      this.setState({
                        wait_approved_data: val.data.data,
                      });
                    });

                  Api.post("get_leave", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    status: "approved",
                    start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                    end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
                  })
                    .then((val) => {
                      this.setState({
                        approved_data: val.data.data,
                      });
                    });

                } else {
                  this.OnViewRejectFailed(this.renderRejectButtonModal())
                }
              });

          } else {
            this.OnViewRejectFailed(this.renderRejectButtonModal())
          }
        });
      await this.setState({
        loading_multi: true,
      })
    }
  }

  setDataTab = async (index) => {
    await this.setState({
      loading: true,
    })

    if (index === 0) {

      await Api.post("get_leave", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        status: "",
        start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
        end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
      })
        .then((val) => {
          this.setState({
            all_data: val.data.data,
            loading: false,
            active: index,
            filterTable: null,
          });
          // this.filterRef.current.resetFields();
        });

    } else if (index === 1) {

      await Api.post("get_leave", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        status: "wait approve",
        start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
        end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
      })
        .then((val) => {
          this.setState({
            wait_approved_data: val.data.data,
            loading: false,
            active: index,
            filterTable: null,

          });
          this.filterRef.current.resetFields();

        });

    } else if (index === 2) {

      await Api.post("get_leave", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        status: "approved",
        start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
        end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
      })
        .then((val) => {
          this.setState({
            approved_data: val.data.data,
            loading: false,
            active: index,
            filterTable: null,

          });
          // this.filterRef.current.resetFields();
        });

    }
  };

 
  setDataSource(item) {
    const { filterTable, wait_approved_data, approved_data, all_data } = this.state;
    if (item == 0) {

      return filterTable == null ? all_data : filterTable;
    } else if (item == 1) {

      return filterTable == null ? wait_approved_data : filterTable;
    } else if (item == 2) {

      return filterTable == null ? approved_data : filterTable;
    }
  }

  // Opening approve
  OnViewApprove(id) {
    this.setState({
      visible_approve: true,
    })
  }

  OnViewReject(id) {
    this.setState({
      visible_reject: true,
    })
  }

  OnViewRejectFailed(id) {
    this.setState({
      visible_reject_failed: true,
    })
  }

 const_a = async (data)=>{
  const { modal_type, modal_data, appv_check, appv_check_emp_multi_job, appv_check_emp_single_job, emp_job } = this.state;
  await this.setState({
    loading_multi: true,
  })

  var approved_multi_emp_job = [];
  for (let i = 0; i < appv_check_emp_multi_job.length; i++) {
    approved_multi_emp_job.push({
      // Required
      company_id: (appv_check_emp_multi_job[i].company_id ? appv_check_emp_multi_job[i].company_id : null),
      operator_id: (appv_check_emp_multi_job[i].operator_id ? appv_check_emp_multi_job[i].operator_id : null),
      project_id: (appv_check_emp_multi_job[i].project_id ? appv_check_emp_multi_job[i].project_id : null),
      job_id: (appv_check_emp_multi_job[i].job_id ? appv_check_emp_multi_job[i].job_id : null),
      job_progress_id: (appv_check_emp_multi_job[i].job_progress_id ? appv_check_emp_multi_job[i].job_progress_id : null),
      location_lat: (appv_check_emp_multi_job[i].location_lat ? appv_check_emp_multi_job[i].location_lat : null),
      location_long: (appv_check_emp_multi_job[i].location_long ? appv_check_emp_multi_job[i].location_long : null),
      progress_Status_flag: (appv_check_emp_multi_job[i].progress_Status_flag ? appv_check_emp_multi_job[i].progress_Status_flag : null),
      reject_service_ma_reason_id: (appv_check_emp_multi_job[i].reject_service_ma_reason_id ? appv_check_emp_multi_job[i].reject_service_ma_reason_id : null),
      reject_service_ma_remark: (appv_check_emp_multi_job[i].reject_service_ma_remark ? appv_check_emp_multi_job[i].reject_service_ma_remark : null),
      create_by: Cookies.get("userId"),
      jobtypeid: (appv_check_emp_multi_job[i].jobtypeid ? appv_check_emp_multi_job[i].jobtypeid : null),
      wf_id: (appv_check_emp_multi_job[i].wf_id ? appv_check_emp_multi_job[i].wf_id : null),
      is_active: (appv_check_emp_multi_job[i].is_active ? appv_check_emp_multi_job[i].is_active : null),
      job_category_name: (appv_check_emp_multi_job[i].job_category_name ? appv_check_emp_multi_job[i].job_category_name : null),
      job_no: (appv_check_emp_multi_job[i].job_no ? appv_check_emp_multi_job[i].job_no : null),
      job_sub_type_id: (appv_check_emp_multi_job[i].job_sub_type_id ? appv_check_emp_multi_job[i].job_sub_type_id : null),
      job_sub_type_name: (appv_check_emp_multi_job[i].job_sub_type_name ? appv_check_emp_multi_job[i].job_sub_type_name : null),
      job_type_name: (appv_check_emp_multi_job[i].job_type_name ? appv_check_emp_multi_job[i].job_type_name : null),
      locatioN_NAME: (appv_check_emp_multi_job[i].locatioN_NAME ? appv_check_emp_multi_job[i].locatioN_NAME : null),
      mainProcessID: (appv_check_emp_multi_job[i].mainProcessID ? appv_check_emp_multi_job[i].mainProcessID : null),
      next_main_process_name: (appv_check_emp_multi_job[i].next_main_process_name ? appv_check_emp_multi_job[i].next_main_process_name : null),
      next_sub_process_name: (appv_check_emp_multi_job[i].next_sub_process_name ? appv_check_emp_multi_job[i].next_sub_process_name : null),
      service_ma_reason_id: (appv_check_emp_multi_job[i].service_ma_reason_id ? appv_check_emp_multi_job[i].service_ma_reason_id : null),
      subProcessID: (appv_check_emp_multi_job[i].subProcessID ? appv_check_emp_multi_job[i].subProcessID : null),
    })
  }

  await Api.post("leave_cancel_job", approved_multi_emp_job)
    .then((val) => {
      if (val.data.result.code !== "F") {

        for (let i = 0; i < appv_check.length; i++) {
          appv_check[i].status = "rejected";
        }
        Api.post("save_leave_multi", appv_check)
          .then((val) => {

            if (val.data.result.code != "F") {
              this.OnViewApprove(this.renderApproveButtonModal())

              Api.post("get_leave", {
                company_id: Cookies.get("companyid"),
                operator_id: Cookies.get("operator_id"),
                project_id: Cookies.get("project_id"),
                status: "",
                start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
              })
                .then((val) => {
                  this.setState({
                    all_data: val.data.data,
                  });
                });

              Api.post("get_leave", {
                company_id: Cookies.get("companyid"),
                operator_id: Cookies.get("operator_id"),
                project_id: Cookies.get("project_id"),
                status: "wait approve",
                start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
              })
                .then((val) => {
                  this.setState({
                    wait_approved_data: val.data.data,
                  });
                });

              Api.post("get_leave", {
                company_id: Cookies.get("companyid"),
                operator_id: Cookies.get("operator_id"),
                project_id: Cookies.get("project_id"),
                status: "approved",
                start_date: moment(this.state.default_startdate).format("YYYY-MM-DD"),
                end_date: moment(this.state.default_enddate).format("YYYY-MM-DD")
              })
                .then((val) => {
                  this.setState({
                    approved_data: val.data.data,
                  });
                });

            } else {
              this.OnViewRejectFailed(this.renderRejectButtonModal())
            }
          });

      } else {
        this.OnViewRejectFailed(this.renderRejectButtonModal())
      }
    });
  await this.setState({
    loading_multi: true,
  })
  }

  onOpenModal = async (name, data) => {
    const { appv_check } = this.state;
    if (name == "approve") {
      await Api.post("get_leave_job_emp", {
        company_id: Cookies.get('companyid'),
        operator_id: Cookies.get('operator_id'),
        project_id: Cookies.get("project_id"),
        // emp_id:  787,
        emp_id: data.emp_id,
        leave_id: data.leave_id,
      })
        .then((val) => {
          if (val.data.result.code == "P") {
            this.setState({
              emp_job: val.data.data.list_job,
              attach_file: val.data.data.attach_file,
              loading: false,
              modal_data: data,
              modal_type: name,
              visible_request: true,
            });
          }
        });

    } else if (name == "reject") {

      await Api.post("get_reason_reject", {
        company_id: Cookies.get("companyid"),
        leave_reason_type_id: "1",
        leave_reason_id: null,
      })
        .then((val) => {
          // if (val.data.data !== null) {
          //     this.OnViewApprove(this.renderApproveButtonModal())
          //     this.rejectForm.current.resetFields();

          // } else {
          //     this.OnViewRejectFailed(this.renderRejectButtonModal())
          // }

          this.setState({
            modal_data: data,
            leave_type_list: val.data.data,
            modal_type: name,
            visible_modal_reject: true,
          });
        });




    } else if (name == "approve multi") {
      var multi_emp = [];
      for (let i = 0; i < appv_check.length; i++) {
        multi_emp.push(appv_check[i].emp_id)
      }
      // var multi_leave_id = [];
      // for (let i = 0; i < appv_check.length ; i++){
      //   multi_emp.push(appv_check[i].multi_leave_id)
      // }

      // // Do API thing
      await Api.post("get_leave_job_emp", {
        company_id: Cookies.get('companyid'),
        operator_id: Cookies.get('operator_id'),
        project_id: Cookies.get("project_id"),
        emp_id: multi_emp.toString(),
        // leave_id: multi_leave_id.toString(),
      })
        .then((val) => {
          if (val.data.result.code == "P") {
            this.setState({
              data_multi_emp: val.data.data.list_job,
              loading: false,
              modal_data: data,
              visible_request_multi: true,
            });
          }
        });
      await this.setState({
        modal_type: name,
        loading_multi: false,
        visible_request_multi: true,
      })

    }

  }

  dateFormat(item) {
    return !item ? "-" : moment(item).format("DD/MM/YYYY HH:mm");
  }

  search = (value) => {
    const { all_data, active, wait_approved_data, approved_data } = this.state;
    var index = 0;
    var setdata = [];
    var obj = {};

    if (active == 0) {
      for (let i = 0; i < all_data.length; i++) {
        for (const [key, value] of Object.entries(all_data[i])) {
          // if (`${key}` !== "inform_job_id") {
          if (value == null || value == undefined) {
            obj[`${key}`] = "-";
          } else {
            obj[`${key}`] = `${value}`;
          }
          // }
        }
        setdata.push(obj);
        setdata.push(index++);
        obj = {};
      }
    } else if (active == 1) {
      for (let i = 0; i < wait_approved_data.length; i++) {
        for (const [key, value] of Object.entries(wait_approved_data[i])) {
          // if (`${key}` !== "inform_job_id") {
          if (value == null || value == undefined) {
            obj[`${key}`] = "-";
          } else {
            obj[`${key}`] = `${value}`;
          }
          // }
        }
        setdata.push(obj);
        setdata.push(index++);
        obj = {};
      }
    } else if (active == 2) {
      for (let i = 0; i < approved_data.length; i++) {
        for (const [key, value] of Object.entries(approved_data[i])) {
          // if (`${key}` !== "inform_job_id") {
          if (value == null || value == undefined) {
            obj[`${key}`] = "-";
          } else {
            obj[`${key}`] = `${value}`;
          }
          // }
        }
        setdata.push(obj);
        setdata.push(index++);
        obj = {};
      }
    }

    const filterTable = setdata.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    this.setState({ filterTable });
  };


  async onReject() {
    const selectReject = await Api.post("get_servicemareasonstoptime_v2", {
      company_id: Cookies.get('companyid'),
      operator_id: Cookies.get('operator_id'),
      project_id: Cookies.get("project_id"),
      ma_reason: "REJECT",
    });
    this.setState({
      maseter_reject: selectReject.data.data.serult_service_reason,
    });
  }

  // Leave Request Modal
  renderModal() {
    const { modal_data, active, loading_approve } = this.state;
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ appv_check_emp_single_job: selectedRows })
      },
    };

    return (
      <Modal
        title={
          <b style={{ color: "#000F9F", fontSize: "20px" }}>Leave Request</b>
        }
        centered
        visible={this.state.visible_request}
        footer={null}
        closable={true}
        onCancel={() => this.setState({ visible_request: false })}
        width={"70%"}
        height={"70%"}
        destroyOnClose
        zIndex={1}
      // className="custom-modal-map-large"
      >
        <Spin spinning={loading_approve}>
          <div className="row">
            <div className="col-12" style={{ backgroundColor: "#F8F9FA" }}>
              <div
                className="row"
                style={{ marginLeft: "0px", marginRight: "0px", padding: "10px" }}
              >

                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Name
                  </span>
                </div>
                <div className="col-3 ">
                  <span style={{ fontSize: "12px", color: "#6F6F6F" }}>
                    {modal_data.emp_name ? modal_data.emp_name : "-"}
                  </span>
                </div>

                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Inform Date
                  </span>
                </div>
                <div className="col-3 ">
                  <span style={{ fontSize: "12px", color: "#6F6F6F" }}>
                    {modal_data.inform_date ? this.dateFormat(modal_data.inform_date) : "-"}
                  </span>
                </div>

                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Leave Type
                  </span>
                </div>
                <div className="col-3 ">
                  <span style={{ fontSize: "12px", color: "#6F6F6F" }}>
                    {modal_data.leave_type_id === 1 ? "ลาป่วย" : null}
                    {modal_data.leave_type_id === 2 ? "ลาพักร้อน" : null}
                    {modal_data.leave_type_id === 3 ? "ลากิจ" : null}
                  </span>
                </div>

                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Start Date
                  </span>
                </div>
                <div className="col-3 ">
                  <span style={{ fontSize: "12px", color: "#6F6F6F" }}>
                    {modal_data.start_date ? this.dateFormat(modal_data.start_date) : "-"}
                  </span>
                </div>

                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Remark
                  </span>
                </div>
                <div className="col-3 ">
                  <span style={{ fontSize: "12px", color: "#6F6F6F" }}>
                    {modal_data.remark ? modal_data.remark : "-"}
                  </span>
                </div>


                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    End Date
                  </span>
                </div>
                <div className="col-3 ">
                  <span style={{ fontSize: "12px", color: "#6F6F6F" }}>
                    {modal_data.end_date ? this.dateFormat(modal_data.end_date) : "-"}
                  </span>
                </div>


                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Attached
                  </span>
                </div>
                <div className="col-3">
                  {this.state.attach_file.map((data, index) => {
                    return (
                      <div className="row" key={index}>
                        <a
                          style={{ fontSize: "12px", color: "blue", textDecoration: "underline" }}
                          href={Api.checkPath(data.pic_url_path, data.pic_upload_name)}
                          download
                        >
                          {data.pic_source_name}
                        </a>
                      </div>
                    );
                  })}
                </div>


                <div className="col-3 " style={{ borderLeft: "2px solid #E8ECEF" }} >
                  <span
                    style={{
                      color: "#0500A3",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Total time
                  </span>
                </div>
                <div className="col-3 ">
                  <span style={{ fontSize: "12px", color: "#6F6F6F" }}>
                    {modal_data.total_day ? modal_data.total_day : "-"}
                  </span>
                </div>
              </div>
            </div>
            <div
              className="col-12 mt-3"
              style={{ border: "1px solid #999BA81F" }}
            >
              <div className="p-2 ">
                <Table
                  size="middle"
                  columns={this.state.columns_leave_request}
                  dataSource={this.state.emp_job}
                  rowKey="job_id"
                  rowSelection={modal_data.status == "wait approve" ? { ...rowSelection } : null}

                />
              </div>
            </div>
            <div className="col-12">
              {this.state.modal_data.status == "wait approve" ?
                <div className="mt-4 text-center">
                  <button
                    type="reset"
                    onClick={() => this.setState({ visible_request: false })}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                  {localStorage.getItem("checkPermission") === "1" ? 
                  <button
                    className="btn btn-success"
                    onClick={() => this.handleSubmit()}
                  >
                    {"Approve"}
                  </button>
                  : null}
                </div>
                : null}

            </div>
          </div>
        </Spin>
      </Modal>
    );
  }

  onChangeGetForm = async (value, object) => {
    const { reject_form } = this.state;
    reject_form["leave_reason_detail"] = object.detail;
  }

  openRejectReasonOpen() {
    this.setState({
      visible_modal_reject: true,
      modal_type: "reject"
    })
  }

  openRejectReasonClose() {
    this.setState({
      visible_modal_reject: false,
      modal_type: "approve"
    })
  }

  renderReject() {
    const { leave_type_list, loading_reject } = this.state;
    return (
      <Modal
        title={<b style={{ color: "#000F9F", fontSize: "20px" }}>Reject</b>}
        centered
        visible={this.state.visible_modal_reject}
        footer={null}
        onCancel={() => this.setState({ visible_modal_reject: false, modal_type: "approve" })}
        closable={true}
        bodyStyle={{ backgroundColor: "#F8F9FA" }}
        width={750}
        destroyOnClose
        zIndex={1}
      >
        <Spin spinning={loading_reject}>
          <Form onFinish={(values, name) => this.handleSubmit(values, name)} ref={this.rejectForm} layout="vertical">
            <div className="row">
              <div className="col-12">
                <Form.Item
                  name="leave_reason_id"
                  label="Reason:"
                >
                  <Select
                    placeholder="Select a Reason"
                    onChange={this.onChangeGetForm}
                  >
                    {(!leave_type_list ? [] : leave_type_list).map((item, index) => (
                      <Select.Option
                        value={item.leave_reason_id}
                        detail={item.leave_reason_detail}
                        key={index}
                      >
                        {item.leave_reason_detail}
                      </Select.Option>
                    ))}


                  </Select>
                </Form.Item>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Form.Item
                  name="leave_reason_remark"
                  label="Remark"
                >
                  <Input.TextArea
                    style={{ maxWidth: "100%", width: "100%", height: "152px" }}
                  />
                </Form.Item>
              </div>
            </div>


            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ width: "120px" }}
                  onClick={() => this.openRejectReasonClose()}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{ width: "120px" }}
                  // onClick={ }
                  className="btn btn-danger" 
                >
                  Reject
                </button>
              </div>
            </div>
          </Form>
        </Spin>
      </Modal>
    );
  }

  exportOption() {
    if (this.state.active == 0) {
      return this.state.all_data
    } else if (this.state.active == 1) {
      return this.state.wait_approved_data
    } else if (this.state.active == 2) {
      return this.state.approved_data
    }
  }

  filterLeaveType(item) {
    const temp_filter = this.state.leave_type_list.filter((element) => { return element.leave_reason_id == item })
    return temp_filter[0].leave_reason_detail;
  }

  exportToXLSX(array) {
    // Change Header
    var headers = {
      doc_no: "Doc No",
      emp_name: "Employee Name",
      emp_nickname: "Employee Nickname",
      remark: "Remark",
      leave_type_id: "Leave Type",
      inform_date: "Inform Date",
      start_date: "Start Date",
      end_date: "End Date",
      total_day: "Total Time",
      status: "Status"
    };

    var result_array = [];

    for (let i = 0; i < array.length; i++) {
      result_array.push({
        doc_no: (array[i].doc_no ? array[i].doc_no : "-"),
        name: (array[i].name ? array[i].name : "-"),
        emp_name: (array[i].emp_name ? array[i].emp_name : "-"),
        emp_nickname: (array[i].emp_nickname ? array[i].emp_nickname : "-"),
        remark: (array[i].remark ? array[i].remark : "-"),
        leave_type_id: (array[i].leave_type_id ? this.filterLeaveType(array[i].leave_type_id) : "-"),
        inform_date: (array[i].inform_date ? moment(array[i].inform_date).format("YYYY-MM-DD") : "-"),
        start_date: (array[i].start_date ? moment(array[i].start_date).format("YYYY-MM-DD") : "-"),
        end_date: (array[i].end_date ? moment(array[i].end_date).format("YYYY-MM-DD") : "-"),
        total_day: (array[i].total_day ? array[i].total_day + " Days" : "-"),
        status: (array[i].status ? array[i].status : "-"),
      })
    }

    // result_array.unshift(headers);

    let binaryWS = XLSX.utils.json_to_sheet([headers, ...result_array], { skipHeader: true });

    // binaryWS['!cols'] = [];
    // binaryWS['!cols'][7] = { hidden: true };
    // binaryWS['!cols'][8] = { hidden: true };
    // binaryWS['!cols'][9] = { hidden: true };
    // binaryWS['!cols'][10] = { hidden: true };

    // Create a new Workbook
    var wb = XLSX.utils.book_new();

    // Name your sheet
    XLSX.utils.book_append_sheet(wb, binaryWS, 'binary values');


    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = yyyy + mm + dd;
    // export your excel
    let filename = ".xlsx";
    switch (this.state.active) {
      case 0:
        filename = "All Data-" + today + ".xlsx"
        break;
      case 1:
        filename = "Wait Approve-" + today + ".xlsx"
        break;
      case 2:
        filename = "Approved-" + today + ".xlsx"
        break;
    }
    XLSX.writeFile(wb, filename);
  }

  renderModalMultiRequest() {
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ appv_check_emp_multi_job: selectedRows })
      },
    };
    return (
      <Modal
        title={
          <b style={{ color: "#000F9F", fontSize: "20px" }}>Leave Request</b>
        }
        centered
        visible={this.state.visible_request_multi}
        footer={null}
        closable={true}
        onCancel={() => this.setState({ visible_request_multi: false })}
        width={750}
        zIndex={2}
        destroyOnClose
      // className="custom-modal-map-large"
      >
        <Spin spinning={this.state.loading_multi}>
          <div className="row">
            <div
              className="col-12"
              style={{ border: "1px solid #999BA81F" }}
            >
              <div className="p-2 ">
                <Table
                  size="middle"
                  columns={this.state.columns_leave_request}
                  dataSource={this.state.data_multi_emp}
                  rowSelection={{ ...rowSelection }}
                  rowKey="job_no"
                />
              </div>
            </div>
            <div className="col-12">
              <div className="mt-4 text-center">
                <button
                  type="reset"
                  onClick={() => this.setState({ visible_request_multi: false })}
                  className="btn btn-secondary"
                >
                  Close
                </button>
                <button
                  className="btn btn-success"
                  onClick={() => this.handleSubmit()}
                >
                  {"Approve"}
                </button>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }

  setDescriptionSuccess() {
    const { modal_type } = this.state;
    if (modal_type == "approve") {
      return "Approve"
    } else if (modal_type == "reject") {
      return "Reject"
    }
  }

  renderApproveButtonModal() {
    const { visible_approve, loading_approve } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_approve}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
          zIndex={3}
        >
          <Spin spinning={loading_approve}>
            <div className="p-3">
              <div className="row">
                <div className="col text-center justify-content-between">
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                </div>
              </div>

              <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
                <div className="col text-center justify-content-between">
                  <span
                    style={{
                      fontFamily: "MontserratM",
                      fontWeight: "bold",
                      color: "#0500A3",
                    }}
                  >
                    {this.setDescriptionSuccess()} Successful
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col text-center justify-content-between">
                  <button
                    type="reset"
                    style={{ height: "30px", width: "100px" }}
                    onClick={() => this.setState({
                      visible_approve: false,
                      visible_modal_reject: false,
                      visible_approve: false,
                      visible_request_multi: false,
                      visible_request: false,
                      appv_check: [],
                      appv_check_emp_single_job: [],
                      appv_check_emp_multi_job: [],
                    })
                    }
                    className="btn btn-warning"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </Spin>
        </Modal>
      </Fragment>
    );
  }

  renderRejectButtonModal() {
    const { visible_reject_failed } = this.state
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_reject_failed}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{ paddingTop: '0', paddingLeft: '15px', paddingRight: '15px', paddingBottom: '0' }}
          zIndex={3}

        >

          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                <img src={Api.absoluteUrl("/icon/reject.svg")} />
              </div>
            </div>

            <div className="row" style={{ margin: '20px 10px 40px 10px' }}>
              <div className="col text-center justify-content-between">
                <span style={{ fontFamily: 'MontserratM', fontWeight: 'bold', color: '#0500A3' }}>
                  <span style={{ color: 'red' }}>{this.setRejecttitle()} Failed, Please Check Your Input</span>
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between" >
                <button type="reset" style={{ height: "30px", width: '100px' }} onClick={() => this.setState({ visible_reject_failed: false })} className="btn btn-warning">Ok</button>
              </div>
            </div>
          </div>

        </Modal>
      </Fragment>
    );
  }

  renderRejectButtonSuccessModal() {
    const { visible_reject_success } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_reject_success}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "15px",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                <img src={Api.absoluteUrl("/icon/reject.png")} />
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  <span style={{ color: "red" }}>Reject</span> Successful
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({
                      visible_reject_success: false,
                      visible: false,
                      reload: true,
                    })

                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  setRejecttitle() {
    if (this.state.modal_type == "reject") {
      return "Appprove"
    } else if (this.state.modal_type == "approve") {
      return "Reject"
    }
  }

  render() {
    const {
      title,
      active,
      tab,
    } = this.state;
    const dateFormatList = ["DD-MM-YYYY", "DD-MM-YY"];
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ appv_check: selectedRows , checkBtn : selectedRows.length > 1 ?  true :  false  });
      },
    };

    return (
      <LayoutOperation active={5}>
        {/* ====================  Display Modal  ====================*/}
        {this.renderModal()}
        {this.renderReject()}
        {this.renderApproveButtonModal()}
        {this.renderRejectButtonModal()}
        {this.renderModalMultiRequest()}
        {this.renderRejectButtonSuccessModal()}

        {this.state.visible ? (
          <ModalSuccess
            status="Successfully"
            path_location="/MaxiOperation/ma_list"
          />
        ) : null}
        {/* ============================================================ */}

        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-3">
                <img
                  src={Api.absoluteUrl("/icon/menu_inform_white.svg")}
                  className="mr-2"
                  style={{ width: "22px", height: "22px" }}
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font18">
                  {title}
                </h2>
              </div>
              <div className="col-6">
                <div className="row justify-content-center">
                  <div className="col-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-mont-b c-white font16">
                        Wait Approve
                      </span>

                      <span
                        className="font-mont-b  font14"
                        style={{ color: "#E8CD00" }}
                      >
                        {this.state.wait_approved_data.length}
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-3 ml-2"
                    style={{ borderLeft: "2px solid #FFFFFF" }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-mont-b c-white font16">Approve</span>
                      <span
                        className="font-mont-b  font14"
                        style={{ color: "#80D51D" }}
                      >
                        {this.state.approved_data.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 text-right">
                <Link to="/" className="c-white font-mont-m font12">
                  <img
                    src={Api.absoluteUrl("/icon/map.svg")}
                    className="mr-1"
                  />
                  Map
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-between row">
              <div className="col-12">
                <div className="d-flex row mt-2">
                  <div className="col-8">
                    <Form ref={this.filterRef}>
                      <Input.Group compact>
                        <Form.Item name="range_picker">
                          <DatePicker.RangePicker
                            format={dateFormatList}
                            onChange={(value) => this.handleDateStartEnd("effective_date", "expire_date", value)}
                          />
                        </Form.Item>
                        <Form.Item name="search_table">
                          <Input.Search
                            placeholder="Search"
                            onSearch={this.search}
                            style={{ width: "335px" }}
                            enterButton
                          />
                        </Form.Item>
                      </Input.Group>
                    </Form>
                  </div>
                  <div className="col-4">
                    <a
                      href={"/MaxiOperation/leave_management_detail"}
                      className="btn btn-warning"
                      style={{ float: "right" }}
                      onClick={() => setCookies(null, 0)}
                    >
                      <img
                        src={Api.absoluteUrl("/icon/leave_management.svg")}
                        width="14"
                        className="mr-2"
                      />
                      Leave Form
                    </a>
                    <button
                      className="btn btn-gray"
                      style={{ float: "right", color: "white", backgroundColor: "#888888" }}
                      onClick={() => this.exportToXLSX(this.exportOption())}
                    >
                      <img
                        src={Api.absoluteUrl("/icon/plus.svg")}
                        width="14"
                        className="mr-2"
                      />
                      Export
                    </button>


                  </div>
                </div>
              </div>
            </div>
            <div className="card-table-ma">
              <ul className="nav">
                {tab.map((item, index) => (
                  <li key={index} className="nav-item font12 font-mont-sb mr-1">
                    {index === 1 ? (
                      <a
                        href="#"
                        onClick={() => this.setDataTab(index)}
                        // className="nav-link no-assign"
                        className={
                          active === index
                            ? "nav-link no-assign active"
                            : "nav-link no-assign"
                        }
                      >
                        {item.text}
                      </a>
                    ) : (
                      <a
                        className={
                          active === index ? "nav-link active" : "nav-link"
                        }
                        onClick={() => this.setDataTab(index)}
                      >
                        {item.text}
                      </a>
                    )}
                  </li>
                ))}
              </ul>

              <div className="body mt-3">
                {active == 1 ?
                  <>
                    <div className="row m-1">
                      <div className="col-4">
                        {localStorage.getItem("checkPermission") === "1" && this.state.checkBtn ? 
                        <>
                        <button
                          style={{
                            height: "30px",
                            width: "100px",
                            margin: "2rem",
                            fontSize: "12px",
                          }}
                          className="btn btn-warning"
                          onClick={() => this.onOpenModal("approve multi", {})}
                        >
                          Approve
                        </button>
                        <button
                          style={{
                            height: "30px",
                            width: "100px",
                            margin: "2rem",
                            fontSize: "12px",
                            backgroundColor:"#e14347",
                            color:"white",
                            border:"1px solid #e14347",
                          }}
                          className="btn btn-warning"
                          onClick={this.const_a}
                        >
                          Reject
                        </button>
                        </>
                        : null}
                      </div>
                      <div className="col-8">
                        <div
                          className="row justify-content-center mr-1"
                          style={{ float: "right" }}
                        >
                          <div className="col-auto text-center">
                            <span className="font-thai-r font16 c-blue">
                              All Employee
                            </span>
                            <h4
                              className="font-thai-b font30"
                              style={{ lineHeight: "24px" }}
                            >
                              {this.state.count_list ?
                                <>
                                  {this.state.count_list[0].emp_total_working ? this.state.count_list[0].emp_total_working : 0}
                                </>
                                :
                                0
                              }
                            </h4>
                          </div>
                          <div className="col-auto text-center">
                            <span className="font-thai-r font16 c-blue">
                              Employee Available
                            </span>
                            <h4
                              className="font-thai-b font30 c-green"
                              style={{ lineHeight: "24px" }}
                            >
                              {this.state.count_list ?
                                <>
                                  {this.state.count_list[0].emp_total_va ? this.state.count_list[0].emp_total_va : 0}
                                </>
                                :
                                0
                              }
                            </h4>
                          </div>
                          <div className="col-auto text-center">
                            <span className="font-thai-r font16 c-blue">
                              Employee Not Available
                            </span>
                            <h4
                              className="font-thai-b font30 c-red"
                              style={{ lineHeight: "24px" }}
                            >
                              {this.state.count_list ?
                                <>
                                  {this.state.count_list[0].emp_total_not_va ? this.state.count_list[0].emp_total_not_va : 0}
                                </>
                                :
                                0
                              }
                            </h4>
                          </div>
                          {/* <div className="col-auto text-center">
                            <span className="font-thai-r font16 c-blue">
                              All Team
                            </span>
                            <h4
                              className="font-thai-b font30 "
                              style={{ lineHeight: "24px" }}
                            >
                              {this.state.count_list ?
                                <>
                                  {this.state.count_list[0].team_total_working ? this.state.count_list[0].team_total_working : 0}
                                </>
                                :
                                0
                              }
                            </h4>
                          </div>
                          <div className="col-auto text-center">
                            <span className="font-thai-r font16 c-blue">
                              Team Available
                            </span>
                            <h4
                              className="font-thai-b font30 c-green"
                              style={{ lineHeight: "24px" }}
                            >
                              {this.state.count_list ?
                                <>
                                  {this.state.count_list[0].team_total_va ? this.state.count_list[0].team_total_va : 0}
                                </>
                                :
                                0
                              }
                            </h4>
                          </div> */}
                        </div>
                        {/* emp_total_ab: 0
                                          emp_total_va: 0
                                          emp_total_working: 442
                                          team_total_ab: 0
                                          team_total_va: 216
                                          team_total_working: 0 */}
                      </div>
                    </div>


                  </>
                  : null}
              </div>
              <div style={{ padding: "5px" }}>
                <Table
                  loading={this.state.loading}
                  columns={this.state.columns}
                  rowKey="leave_id"
                  dataSource={this.setDataSource(active)}
                  rowSelection={localStorage.getItem("checkPermission") === "1" ? active == 1 ? { ...rowSelection } : null : null}
                  size="middle"
                  total={this.setDataSource(active).length}
                  pagination={{
                    defaultPageSize: 10,
                    defaultCurrent: 1,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} Entries`,
                    pageSizeOptions: ["10", "20", "50"],
                    showSizeChanger: true,
                    locale: { items_per_page: "" }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

export default LeaveList;
